import { Stack, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import MerchantInfo from "src/components/common/MerchantInfo";

const BindUserParentDialog = ({ user, open, onReload, onClose }) => {
  const [parent, setParent] = useState({});

  const [form, setForm] = useState({
    remark: ''
  });

  useEffect(() => {
    if (!user.pid) return;
    getUserParent();
  }, [])

  async function getUserParent() {
    const { data } = await asyncRequest({
      path: "/user/parent",
      data: {
        fromMer: user.fromMer,
        pid: user.pid
      }
    });

    setParent(data);
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    if (!form.remark) return alert('请输入修改原因');
    
    const { msg } = await asyncRequest({
      path: "/user/changeParent",
      data: {
        ...form,
        uid: user.uid,
        pid: parent.uid,
      },
    });

    setForm({
      nickname: "",
    });
    alert(msg, "success");
    onClose();
    onReload();
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        setParent(val);
      },
    });
  }

  return (
    <FormDialog title="设置推荐人" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="用户" required>
        <Stack direction="row" alignItems="center" spacing={2}>
          <UserInfo {...user} enablePreview={false} />
        </Stack>
      </FormItem>

      <FormItem title="推荐人" required>
        <Stack direction="row" alignItems="center" spacing={2} onClick={handleSelectUser}>
          {user.fromMer ? <MerchantInfo  {...(parent || {})} /> : <UserInfo {...(parent || {})} enablePreview={false} /> }
        </Stack>
      </FormItem>

      <FormItem title="备注" required>
        <TextField fullWidth value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} rows={4} multiline />
      </FormItem>
    </FormDialog>
  );
};

export default BindUserParentDialog;
